import { render } from "./icon_triangle_bottom.svg?vue&type=template&id=296d9f83"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__